
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";

const CateringAboutmaamaas = () => {
  const [aboutData, setAboutData] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [vendorId, setVendorId] = useState(null);

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId) {
          console.warn("Missing vendorId");
          return;
        }

        const res = await axios.get(
          `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/aboutus/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data) {
          setAboutData(res.data);
        }
      } catch (err) {
        console.error("❌ Failed to fetch about data:", err);
      }
    };

    fetchAboutData();
  }, []);

  const toImageSrc = (raw) => {
    if (!raw || raw.trim() === "" || raw.trim() === "/") return "/placeholder.svg";
    
    const clean = raw.trim();

    // If it's already a data URL or external URL, return as is
    if (clean.startsWith("data:image")) return clean;
    if (/^https?:\/\//i.test(clean)) return clean;
    
    // Check if it's base64 data (typically long string)
    if (clean.length > 100) {
      const mime = clean.startsWith("iVBORw0KGgo") ? "image/png" : "image/jpeg";
      return `data:${mime};base64,${clean}`;
    }

    // MinIO URL construction
    const minioBaseUrl = "http://10.10.20.9:9000";
    
    // If it's already a full MinIO path, use as is
    if (clean.startsWith("catering/") || clean.includes("/")) {
      return `${minioBaseUrl}/${clean}`;
    }
    
    // If it's just a filename, assume it's in catering bucket
    return `${minioBaseUrl}/catering/${clean}`;
  };

  return (
    <Container fluid className="py-5" style={styles.container}>
      <style>
        {`
          /* Mobile First Styles */
          .about-row {
            flex-direction: column;
            padding: 15px !important;
            margin: 0 10px !important;
          }
          
          .about-text {
            padding: 0 15px !important;
            margin-top: 20px !important;
          }
          
          .about-img {
            max-height: 250px !important;
            height: 250px !important;
          }

          /* Tablet Styles */
          @media (min-width: 576px) {
            .about-row {
              margin: 0 20px !important;
              padding: 20px !important;
            }
            
            .about-text {
              padding: 0 25px !important;
            }
            
            .about-img {
              max-height: 300px !important;
              height: 300px !important;
            }
          }

          /* Small Desktop */
          @media (min-width: 768px) {
            .about-row {
              flex-direction: row !important;
              margin: 0 auto !important;
              padding: 30px !important;
            }
            
            .about-text {
              padding: 0 30px !important;
              margin-top: 0 !important;
            }
            
            .about-img {
              max-height: 350px !important;
              height: 350px !important;
            }
          }

          /* Large Desktop */
          @media (min-width: 1200px) {
            .about-row {
              
              padding: 40px !important;
            }
            
            .about-text {
              padding: 0 40px !important;
            }
            
            .about-img {
              max-height: 400px !important;
              height: 400px !important;
            }
          }

          /* Extra Small Devices */
          @media (max-width: 375px) {
            .about-row {
              padding: 10px !important;
              margin: 0 5px !important;
            }
            
            .about-text {
              padding: 0 10px !important;
            }
            
            .about-img {
              max-height: 200px !important;
              height: 200px !important;
            }
          }
        `}
      </style>

      <Row className="align-items-center about-row" style={styles.row}>
        <Col
          md={6}
          className="about-text"
          style={{
            order: isMobile ? 2 : 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h1 style={styles.heading}>ABOUT US</h1>
          {aboutData.aboutUs ? (
            <p style={styles.text}>{aboutData.aboutUs}</p>
          ) : (
            <p style={styles.text}>No content available at the moment.</p>
          )}
        </Col>

        <Col
          md={6}
          className="text-center p-4"
          style={{ order: isMobile ? 1 : 2 }}
        >
          <img
            src={aboutData?.image ? toImageSrc(aboutData.image) : "/placeholder.svg"}
            alt="About Us"
            style={styles.image}
            className="about-img"
          />
        </Col>
      </Row>
    </Container>
  );
};

const styles = {
  container: {
    padding: "20px 0",
    borderRadius: "12px",
    backgroundColor: "#fff",
  },
  row: {
    borderRadius: "10px",
    margin: "0 auto",
    maxWidth: "100%",
    display: "flex",
    flexWrap: "wrap",
    padding: "20px",
    backgroundColor: 'rgb(177 93 198)',
  },
  heading: {
    color: "rgb(255 225 36)",
    fontWeight: "bold",
    fontSize: "clamp(24px, 5vw, 32px)", // Responsive font size
    marginBottom: "20px",
    textAlign: "left",
    fontFamily: "revert",
    lineHeight: "1.2"
  },
  image: {
    width: "100%",
    objectFit: "cover",
    borderRadius: "12px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
  },
  text: {
    fontSize: "clamp(14px, 2.5vw, 16px)", // Responsive font size
    color: "#fff",
    lineHeight: "1.6",
    textAlign: "justify",
    whiteSpace: "pre-line",
    fontFamily: 'math',
    marginBottom: "0"
  },
};

export default CateringAboutmaamaas;









